export default __webpack_public_path__ + "static/media/rakeback-img.8483d61f.png";